import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CheckboxListFiltrMoby from './FiltrCompanentMoby/CheckboxListFiltrMoby';
import DisplayTypeCompanentMobyA from './FiltrCompanentMoby/DisplayTypeCompanentMoby/DisplayTypeCompanentMobyA';
import DisplayTypeCompanentPriceMoby from './FiltrCompanentMoby/DisplayTypeCompanentMoby/DisplayTypeCompanentPriceMoby';


const ConfirmationDialogRaw = (props) => {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const [checked, setChecked] = React.useState(props.checked);

    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);

    const handleEntering = () => {
        // if (radioGroupRef.current != null) {
        //     radioGroupRef.current.focus();
        // }
    };

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const RemoveChecks = () => {
        checked[props.code] = [];
        setChecked(checked);
        props.setCheckenFiltr(checked);
        props.submitForm();
    }
    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: 1, height: "inherit", m: 0, borderRadius: 0 } }}
            maxWidth="xs"
            TransitionProps={{ onEntering: handleEntering }}
            open={open}
            {...other}
        >
            <DialogTitle>{props.name}
                {props.checked[props.code]?.length >= 1 && (
                    <Button variant="text" size="small" onClick={RemoveChecks} sx={{ color: '#404040', float: "right" }}>Очистить</Button>
                )}
            </DialogTitle>
            <DialogContent dividers>
                <CheckboxListFiltrMoby {...props} />
            </DialogContent>
            <DialogActions sx={{ backgroundColor: '#404040', justifyContent: 'center' }} >
                <Button autoFocus onClick={handleCancel} sx={{ color: '#fff' }}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setCheckenFiltr: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

const ConfirmationDialogMoby = (props) => {
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState('еуые');
    const [valueClik, setStateClik] = React.useState('');
    const [indexClik, setIndexClik] = React.useState('');
    const [checked, setChecked] = React.useState(props.checked);

    const handleClickListItem = (id, index, displaytype, nopopup= "") => {
        
        if (displaytype !== "A") {
            if (displaytype !== "" || nopopup !== "no popup" ) {
            
            setStateClik(id);
            setOpen(true);
            setIndexClik(index)
            }
        }

    }

    const handleClose = (newValue) => {
        setOpen(false);

        if (newValue) {
            setValue(newValue);
        }
    };
    const RemoveChecks = (e) => {
        
        let code = e.target.dataset.code;
        checked[code] = [];
        setChecked(checked);
        props.setCheckenFiltr(checked);
        props.submitForm();
        handleClickListItem("", "", "", "no popup")
    }

    return (
        <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', mb:9 }}>
            <List component="div" role="group" >
                {props.filterItems.map((u, index) => (
                    <ListItem
                        key={index}
                        button
                        divider
                        aria-haspopup={u.DISPLAY_TYPE !== "A" ? "true" : "false"}
                        aria-controls={u.DISPLAY_TYPE !== "A" ? u.CODE + "-menu" : ""}
                        aria-label={u.DISPLAY_TYPE !== "A" ? u.NAME : ""}
                        
                    >
                        {u.DISPLAY_TYPE !== "A" ? (
                            <>
                                <ListItemText primary={u.NAME} secondary={props.checked[u.CODE]?.length >= 1 ? "Выбрано " + props.checked[u.CODE].length : ""} onClick={() => handleClickListItem(u.CODE, index, u.DISPLAY_TYPE)} />
                                {props.checked[u.CODE]?.length >= 1 && (
                                    <Button variant="contained" color="success" size="small" data-code={u.CODE} onClick={RemoveChecks}>Очистить</Button>
                                )}
                            </>
                        ) :
                            <div>
                                {u.CODE == "width" && (
                                    <DisplayTypeCompanentPriceMoby submitForm={props.submitForm} setCheckenFiltr={props.setCheckenFiltr} name={"Цена"} propertyValuePrice={props.getPriceSlide} propertyValuePriceMaxMin={props.getPriceSlideMaxMin} code={"price"} checked={props.checked} />
                                )}

                                <DisplayTypeCompanentMobyA submitForm={props.submitForm} id={u.ID} setCheckenFiltr={props.setCheckenFiltr} name={u.NAME} propertyValue={u.PROPERTY_VALUE} code={u.CODE} typeDisplay={u.DISPLAY_TYPE} checked={props.checked} />
                            </div>


                        }

                    </ListItem>

                ))}

                <ConfirmationDialogRaw
                    code={props.filterItems[indexClik]?.CODE}
                    displaytype={props.filterItems[indexClik]?.DISPLAY_TYPE}
                    name={props.filterItems[indexClik]?.NAME}
                    propertyvalue={props.filterItems[indexClik]?.PROPERTY_VALUE}
                    propertyvaluecolor={props.filterItems[indexClik]?.PROPERTY_VALUE.HighloadBlockValue}
                    typedisplay={props.filterItems[indexClik]?.DISPLAY_TYPE}
                    setCheckenFiltr={props.setCheckenFiltr}
                    submitForm={props.submitForm}
                    checked={props.checked}
                    id={valueClik + "-menu"}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    value={value}
                />

            </List>
        </Box>
    );
}

export default ConfirmationDialogMoby;